'use client';

import { c as _c } from "react/compiler-runtime";
import React, { createContext, useCallback, useContext, useState } from 'react';
import canUseDOM from '@/utilities/canUseDOM';
const initialContext = {
  headerTheme: undefined,
  setHeaderTheme: () => null
};
const HeaderThemeContext = createContext(initialContext);
export const HeaderThemeProvider = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = canUseDOM ? document.documentElement.getAttribute("data-theme") : undefined;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [headerTheme, setThemeState] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = themeToSet => {
      setThemeState(themeToSet);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const setHeaderTheme = t2;
  let t3;
  if ($[2] !== headerTheme) {
    t3 = {
      headerTheme,
      setHeaderTheme
    };
    $[2] = headerTheme;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== children || $[5] !== t3) {
    t4 = <HeaderThemeContext.Provider value={t3}>{children}</HeaderThemeContext.Provider>;
    $[4] = children;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export const useHeaderTheme = () => {
  return useContext(HeaderThemeContext);
};